module.exports = __webpack_public_path__ + "img/masterCard.f44547de.svg";